const ProductViewModule = {
  namespaced: true,
  state: {
    data: [],
    countCertificate: 0,
    countDisease: 0,
    countPropagation: 0,
    countWorkflow: 0,
    countProperties: 0,
    countPhases: 9
  },
  mutations: {
    countCertificate(state, payload) {
      state.countCertificate = payload
    },
    countDisease(state, payload) {
      state.countDisease = payload
    },
    countPropagation(state, payload) {
      state.countPropagation = payload
    },
    countWorkflow(state, payload) {
      state.countWorkflow = payload
    },
    countProperties(state, payload) {
      state.countProperties = payload
    },
    countPhases(state, payload){
      state.countPhases = payload
    },
    FETCH(state, payload) {
      state.data = []
      state.data = payload
    },
    DELETE: (state, payload) => {
      var index = state.data.findIndex(data => data.productid === payload)
      state.data.splice(index, 1)
    }
  },
  actions: {
    async fetch({ commit }, payload) {
      try {
        const response = await axios.get(`/getProductBy/id/${payload}`)
        commit('FETCH', response.data.details)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        await axios.delete(`getProductBy/id/${payload}`)
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default ProductViewModule



// WEBPACK FOOTER //
// ./src/store/modules/product/product_view.js